'use strict';

let isDesktop = require('./utilities/clientSideUtil').isDesktop;
let isMobile = require('./utilities/clientSideUtil').isMobile;
let desktopPerView = 5;
let ipadPerView = 2;
let mobilePerView = 2;
import {Glide, Controls, Swipe, Breakpoints, Images, Keyboard } from './components/carousel'

/**
 * Creates carousel bullet items
 * @param {jQuery} $parentEl container element
 */
function createControls($parentEl) {
    const $carouselItems = $($parentEl).find('.glide__slide').not('.glide__slide--clone');
    let $carouselBullets = $($parentEl).find('[data-glide-el="controls[nav]"]');
    $carouselItems.each(function (index) {
        var $newIndiator = $(`<button class="glide__bullet" data-glide-dir="=${index}" aria-label="Slide ${index+1}"></button>`);
        $carouselBullets.append($newIndiator);
    });
    $carouselBullets.removeClass('d-none');
}

/**
 * Initialize carousel
 * @param {jQuery} $containerEl the wrapper element
 * @param {number} gapValue - The gap value between carousel items
 */
function initCarouselLayout($containerEl, gapValue) {
    const $carousel = $($containerEl);
    const $carouselItems = $($carousel).find('.glide__slide').not('.glide__slide--clone');
    const $controls = $($carousel).find('[data-glide-el="controls"]');
    const $bullets = $($carousel).find('.glide__bullets');
    const $glideControls = $($carousel).find('.glide__controls');
    const totalSlides = $carouselItems.length;
    if ($carousel.data('layout-type') === 1 || $carousel.data('layout-type') === 2) {
        mobilePerView = 1;
    } else {
        mobilePerView = 2;
    }

    let glide;
    const defaults = {
        type: 'slider',
        perView: desktopPerView,
        rewind: false,
        bound: true,
        gap: gapValue,
        breakpoints: {
            1199: {
                rewind: true,
                gap: 24,
                perView: ipadPerView,
                bound: false
            },
            767: {
                rewind: true,
                gap: 16,
                perView: mobilePerView,
                bound: false
            }
        }
    };

    const handleUpdateEvent = () => {
        if (!glide) { return; }
        const { perView } = glide.settings;
        if (totalSlides <= perView) {
            $controls.addClass('d-none');
            $glideControls.removeClass('d-flex').addClass('d-none');
            $bullets.removeClass('d-flex').addClass('d-none');
        } else {
            $controls.removeClass('d-none');
            $glideControls.removeClass('d-none').addClass('d-flex');
            $bullets.removeClass('d-none').addClass('d-flex');
        }
    }

    glide = new Glide($carousel.get(0), defaults)
        .on('build.before', handleUpdateEvent)
        .mount({
            Controls,
            Breakpoints,
            Swipe,
            Images,
            Keyboard
        });
    
    handleUpdateEvent()
}

/**
 * Removing unslider class to align the layout
 * @param {jQuery} $parentEl container element
 */
function createUnsliderLayout($parentEl) {
    $($parentEl).addClass('layout-glide-section');
    $($parentEl).removeClass('glide mbb-glide-carousel');
    $($parentEl).find('.track-section').removeClass('glide__track');
    $($parentEl).find('.sliders-container').removeClass('glide__slides').addClass('row justify-content-center');
    $($parentEl).find('.glide__controls').addClass('d-none').removeClass('d-flex');
}

/**
 * Initializes the carousel layout by creating controls and setting up the carousel layout.
 * @param {string} $carousel carousel element
 * @param {number} gapValue - The gap value between carousel items
 */
const initializeCarousel = ($carousel, gapValue) => {
    createControls($carousel);
    initCarouselLayout($carousel, gapValue);
};

/**
 * Creates the layout for the carousel based on the total number of slides and whether the device is a desktop.
 * 
 * @param {number} slideCount - The total number of slides in the carousel.
 * @param {boolean} desktopDevice - Check if device is a desktop.
 * @param {string} $carousel - Get carousel element.
 */
const createLayout = (slideCount, desktopDevice, $carousel) => {
    let colValue = '';
    
    if ((slideCount === 3 || slideCount === 4) && !desktopDevice) {
        initializeCarousel($carousel, 24);
        return;
    } 
    
    if (slideCount === 2 && isMobile()) {
        initializeCarousel($carousel, 24);
        return;
    }

    if (slideCount === 1) {
        colValue = 'col-12';
    } else if (slideCount === 2) {
        colValue = desktopDevice ? 'col-6' : 'col-12 col-md-6';
    } else if (slideCount === 3) {
        colValue = desktopDevice ? 'col-4' : '';
    } else if (slideCount === 4) {
        colValue = desktopDevice ? 'col-3' : '';
    }

    if (colValue) {
        $carousel.find('.glide__slide').addClass(colValue);
    }

    createUnsliderLayout($carousel);
};

$(document).ready(function () {
    $('.ritz-content-blocks').each(function () {
        const $carousel = $(this).find('.js-ritz-content-blocks-carousel');
        const totalSlides = $carousel.find('.glide__slide').not('.glide__slide--clone').length;

        if ($(this).hasClass('ritz-layout--type-1')) {
            desktopPerView = 1;
            ipadPerView = 1;
            mobilePerView = 1;
            initializeCarousel($carousel, 24);
        } else if ($(this).hasClass('ritz-layout--type-2')) {
            if (totalSlides <= 2) {
                createLayout(totalSlides, isDesktop(), $carousel);
            } else {
                desktopPerView = 2;
                initializeCarousel($carousel, 72);
            }
        } else if ($(this).hasClass('ritz-layout--type-3')) {
            if (totalSlides < 3) {
                createLayout(totalSlides, isDesktop(), $carousel);
            } else {
                desktopPerView = 3;
                initializeCarousel($carousel, 24);
            }
        } else if ($(this).hasClass('ritz-layout--type-4')) {
            if (totalSlides < 4) {
                createLayout(totalSlides, isDesktop(), $carousel);
            } else {
                desktopPerView = 4;
                initializeCarousel($carousel, 24);
            }
        } else if ($(this).hasClass('ritz-layout--type-5')) {
            if (totalSlides < 5) {
                createLayout(totalSlides, isDesktop(), $carousel);
            } else {
                desktopPerView = 5;
                initializeCarousel($carousel, 24);
            }
        }
    });
});
